export const REVIEW_WORDING_VERSION = 'review-email-v1'
export const REVIEW_PERMISSION_COPY = 'I would like this workshop to email me an optional invitation to share an honest Google review after full payment. I can stop these invitations at any time. This does not affect my service or essential job emails.'

export function googleReviewUrl(value) {
  try {
    const u = new URL(String(value).trim())
    if (u.protocol !== 'https:' || u.username || u.password || u.port || u.hash) return ''
    if (u.hostname === 'g.page' && /^\/r\/[A-Za-z0-9_-]+\/review$/.test(u.pathname) && !u.search) return u.href
    if (u.hostname === 'search.google.com' && u.pathname === '/local/writereview'
      && [...u.searchParams.keys()].length === 1 && /^[A-Za-z0-9_-]{5,200}$/.test(u.searchParams.get('placeid') || '')) return u.href
  } catch {}
  return ''
}

export function emailAddress(value) {
  const text = String(value || '').trim().toLowerCase()
  return /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9.-]*[a-z0-9])?\.[a-z]{2,}$/.test(text) && text.length <= 254 ? text : ''
}

const escape = value => String(value || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]))

// Pure preview: no tokens, provider calls, queue writes or click tracking.
export function reviewEmail({ workshopName, fromEmail, replyTo, recipient, reviewUrl, optOutUrl }) {
  const name = String(workshopName || '').trim()
  if (!name || name.length > 120 || /[\r\n<>]/.test(name)) throw new Error('Workshop name needs review.')
  const destination = googleReviewUrl(reviewUrl)
  if (!destination) throw new Error('Use a supported Google review link.')
  if (!emailAddress(fromEmail) || !emailAddress(replyTo) || !emailAddress(recipient)) throw new Error('Email identity needs setup.')
  const subject = `Share your experience with ${name}`
  const paragraphs = [
    `Thank you for choosing ${name}.`,
    'If you would like to, please share an honest review of your experience on Google. All feedback is welcome, and leaving a review is entirely optional.',
    `Leave a Google review: ${destination}`,
    `Thank you,\n${name}`,
    `You received this invitation because you chose to receive review invitations from ${name}.`,
    `Stop review invitations: ${optOutUrl}`,
  ]
  return { from: `"${name.replace(/["\\]/g, '')}" <${emailAddress(fromEmail)}>`, to: [emailAddress(recipient)], reply_to: emailAddress(replyTo), subject,
    text: paragraphs.join('\n\n'), html: `<div style="font-family:Arial,sans-serif;max-width:560px;margin:auto;line-height:1.6;color:#20252b"><h1 style="font-size:22px">${escape(name)}</h1><p>${escape(paragraphs[0])}</p><p>${escape(paragraphs[1])}</p><p><a href="${escape(destination)}">Leave a Google review</a></p><p>Thank you,<br>${escape(name)}</p><hr><p style="font-size:12px">${escape(paragraphs[4])}</p><p><a href="${escape(optOutUrl)}">Stop review invitations</a></p></div>` }
}
